import React from "react";
import Media from "react-media";
import "./AddUser.css";
import { HeaderDesktop } from "../../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../../components/header/mobile/HeaderMobile";
import { ProgressBar } from "../../../components/progress-bar/ProgressBar";
import { Button, TextField } from "@material-ui/core";
import { AddUserState } from "../../../states/AddUserState";
import { Route } from "react-router-dom";
import { createRef } from "react";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { TerminalOperationType } from "../../../utils/TerminalOperationTypeEnum";
import $ from "jquery";
import StateContextProvider from "../../../context/StateContext";

export class AddUser extends React.Component<any, AddUserState> {
  emailInputRef: any;
  roleInputRef: any;
  innerHeight: number;
  private ua = navigator.userAgent.toLowerCase();
  private isAndroid = this.ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
  constructor(props: any) {
    super(props);
    this.state = {
      emailValue: "",
      descriptionValue: "",
      emailError: false,
      buttonDisabled: true,
      showDialog: false,
      sameTerminalsType: false,
      allTerminalsType: "",
    };

    this.handleEmailChanges = this.handleEmailChanges.bind(this);
    this.handleDescriptionChanges = this.handleDescriptionChanges.bind(this);
    this.handleMailKeyDown = this.handleMailKeyDown.bind(this);
    this.handleRoleKeyDown = this.handleRoleKeyDown.bind(this);

    this.emailInputRef = createRef();
    this.roleInputRef = createRef();
    this.innerHeight = window.innerHeight;
  }

  componentDidMount() {
    this.setState({
      sameTerminalsType: StateContextProvider.getInstance().getProp("sameTerminalsType"),
      allTerminalsType: StateContextProvider.getInstance().getProp("allTerminalsType"),
    });
    GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, "Crea nuova utenza", {});
  }

  private static renderDesktopHeader(): JSX.Element {
    return <HeaderDesktop showBack={true} showLogout={false} showTitle={true} showBackText={true} title={"Crea nuova utenza"} />;
  }

  private static renderMobileHeader(): JSX.Element {
    return <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={"Crea nuova utenza"} />;
  }

  private handleEmailChanges(event: any) {
    this.setState({ emailValue: event.target.value });
  }

  private handleDescriptionChanges(event: any) {
    this.setState({ descriptionValue: event.target.value });
  }

  private toggleModal = () => {
    this.setState({
      showDialog: !this.state.showDialog,
    });
  };

  private goToSecondStep(history: any) {
    this.state.sameTerminalsType
      ? history.push("/chooseTerminal", {
        email: this.state.emailValue,
        description: this.state.descriptionValue,
        headerTitle: "Crea nuova utenza",
        tidOperation: TerminalOperationType.ADD_TERMINAL_ID_TO_USER,
        terminalType: this.state.allTerminalsType,
      })
      : history.push("/selectTerminalTypes", {
        email: this.state.emailValue,
        description: this.state.descriptionValue,
      });
  }

  private validateMailOnBlur() {
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(this.state.emailValue.toLowerCase())) {
      this.setState({ emailError: true });
      this.setState({ buttonDisabled: true });
      GoogleTagManagerService.getInstance().pushInputErrorWithFieldEvent("email", "E-mail non valida. Controlla e riprova.");
    } else {
      this.setState({ emailError: false });
      this.setState({ buttonDisabled: false });
    }
  }

  private resetEmailField() {
    this.setState({ emailError: false });
  }

  private handleMailKeyDown(event: any) {
    if (event.key === "Enter") {
      console.log("[AddUser] Done clicked!");
      if (this.emailInputRef !== undefined) {
        this.emailInputRef.current.blur();
      }
    }
  }

  private handleRoleKeyDown(event: any) {
    if (event.key === "Enter") {
      console.log("[AddUser] Done clicked!");
      if (this.roleInputRef !== undefined) {
        this.roleInputRef.current.blur();
      }
    }
  }

  private goToActivateDev(history: any) {
    GoogleTagManagerService.getInstance().pushCta("abilita utenza sviluppatore", "MuiButtonBase-root MuiButton-root MuiButton-text", "/activateDev");
    history.push("/activateDev");
  }

  render() {
    return (
      <div id={"main-container-add-user"}>
        {this.state.sameTerminalsType ? null : <ProgressBar value={33.33} />}
        <Media query="(max-width: 1064px)" render={() => AddUser.renderMobileHeader()} />
        <Media query="(min-width: 1065px)" render={() => AddUser.renderDesktopHeader()} />
        <div className={"add-user-container-content"} id={"add-user-content"}>
          <div className={"add-user-content"}>
            <p className={"add-user-title"}>Inserisci i dati del dipendente</p>
            <p className={"add-user-subtitle"}>
              I tuoi dipendenti possono accettare pagamenti a nome della tua attività,
              <br className="hide-on-mobile" /> accedere all’App e vedere le transazioni relative al ID Terminale a loro
              <br className="hide-on-mobile" /> assegnato.
            </p>
            <TextField
              id={"add-user-email-field"}
              label="Email del dipendente"
              type={"email"}
              inputRef={this.emailInputRef}
              onChange={this.handleEmailChanges}
              value={this.state.emailValue}
              error={this.state.emailError}
              onBlur={() => {
                this.validateMailOnBlur();
              }}
              onFocus={() => {
                this.resetEmailField();
                if (this.isAndroid) {
                  let current = $("#add-user-content").height()!;
                  $("#add-user-content").height(current);
                }
              }}
              onKeyDown={this.handleMailKeyDown}
            />
            <p className={this.state.emailError ? "add-user-email-error" : "add-user-email-error add-user-label-error-hide"}>
              E-mail non valida. Controlla e riprova.
            </p>
            <TextField
              id={"add-user-description-field"}
              label="Ruolo o punto vendita (opzionale)"
              type={"text"}
              onChange={this.handleDescriptionChanges}
              onKeyDown={this.handleRoleKeyDown}
              inputRef={this.roleInputRef}
              onFocus={() => {
                if (this.isAndroid) {
                  let current = $("#add-user-content").height()!;
                  $("#add-user-content").height(current);
                }
              }}
              value={this.state.descriptionValue}
              inputProps={{ maxLength: 20 }}
            />
          </div>
          <p className="add-user-separator-text">oppure</p>
          <Route
            render={({ history }) => {
              return (
                <Button
                  id={"add-user-link-button"}
                  onClick={() => {
                    this.goToActivateDev(history);
                  }}
                  disableRipple>
                  {"Abilita utenza sviluppatore"}
                </Button>
              );
            }}
          />
        </div>
        <div className={"add-user-buttons-container"}>
          <Route
            render={({ history }) => {
              return (
                <Button
                  id={"add-user-go-to-next-step-button"}
                  type={"button"}
                  disabled={this.state.buttonDisabled}
                  onClick={() => this.goToSecondStep(history)}>
                  AVANTI
                </Button>
              );
            }}
          />
        </div>
      </div>
    );
  }
}
